"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var react_1 = __importDefault(require("react"));
var Card_1 = __importDefault(require("@material-ui/core/Card"));
var Card = function (_a) {
    var classes = _a.classes, children = _a.children, _b = _a.raised, raised = _b === void 0 ? false : _b;
    return (react_1.default.createElement(Card_1.default, { classes: classes, raised: raised }, children));
};
exports.default = Card;
